import { useState } from "react"
import KYCUploadComponent from "./KYCUploadComponent"
import { ThemeProvider, createTheme } from "@mui/material/styles"
import CssBaseline from "@mui/material/CssBaseline"

const theme = createTheme({
    palette: {
      primary: {
        main: "#1976d2",
      },
      secondary: {
        main: "#dc004e",
      },
    },
})
  

const KYCNew = ({selectedUser, selectedUserData}) => {
  const isMerchantDataValid = selectedUserData?.merchantdata && selectedUserData?.merchantdata.Merchant?.active == "1";

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <KYCUploadComponent 
        // userType="both" 
        userType={isMerchantDataValid ? "both" : "user"} 
        selectedUser={selectedUser} 
        selectedUserData={selectedUserData} 
      />
    </ThemeProvider>
  )
}
  

export default KYCNew
